import React from 'react';
import {View, Pressable, Platform} from 'react-native';
import CachedImage from '../../elements/CachedImage';
import Text from '../../elements/Text';
import Button from '../../elements/Button';
import makeStyles from './styles.web';
import {useTheme, useThemedStyles} from '../../../theme';
import {COLORS, BUTTON_TYPES} from '../../../utils/Constants';
import CommonStyles from '../../../utils/CommonStyles';
import {tID} from '../../../utils/TestIdHelper';
import {DownArrowIcon, Logo, UpArrowIcon} from '../../../utils/SvgIcons';

const UI = ({
  product,
  isFree,
  networkImage,
  imageStyle = {},
  style,
  productQty = 1,
  onPressAddToCart = () => {},
  updateProductQty = () => {},
}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('CatalogProductCard-View-MainContainer')}
      style={style ? style : styles.container}>
      <View style={styles.imageConatiner}>
        {networkImage ? (
          <CachedImage
            testID={tID('CatalogProductCard-CachedImage-Product')}
            source={networkImage}
            style={
              Platform.OS === 'web'
                ? {...styles.productImage, ...imageStyle}
                : [styles.productImage, imageStyle]
            }
          />
        ) : (
          <Logo
            testID={tID('CatalogProductCard-Image-Logo')}
            width={125}
            height={125}
            style={imageStyle}
          />
        )}
      </View>

      <View style={styles.detailsConatiner}>
        <Text
          testID={tID('CatalogProductCard-Text-Title')}
          numberOfLines={2}
          variation="Body1SemiBold"
          color={colors.link}
          style={CommonStyles.full_flex}>
          {product.title}
        </Text>
        {isFree ? (
          // Brand-purple "Free For Me" badge stays literal (decorative
          // palette — DARK-MODE.md; low dark-mode contrast is a known gap
          // flagged for design follow-up).
          <Text
            testID={tID('CatalogProductCard-Text-Free')}
            variation="Text1SemiBold"
            color={COLORS.purple}
            style={styles.freeText}>
            Free For Me
          </Text>
        ) : (
          <Text
            testID={tID('CatalogProductCard-Text-Price')}
            variation="Subtitle1SemiBold"
            color={colors.link}
            style={CommonStyles.self_start}>
            $ {parseFloat(product.price).toFixed(2)}
          </Text>
        )}
        {/* functionality for adding quantity and add to cart will done in next tickets */}
        <View style={styles.addContainer}>
          <View
            testID={tID('CatalogProductCard-View-CountContainer')}
            style={styles.qtyContainer}>
            <Pressable
              testID={tID('CatalogProductCard-Pressable-CountDecrease')}
              hitSlop={styles.hitSlop}
              disabled={productQty === 1}
              style={styles.arrowImgContainer}
              onPress={() => updateProductQty(productQty - 1)}>
              <DownArrowIcon
                tintColor={productQty === 1 ? colors.borderMuted : colors.link}
              />
            </Pressable>
            <View style={styles.qtyTextContainer}>
              <Text
                testID={tID('CatalogProductCard-Text-Count')}
                variation="Body1Regular"
                color={colors.textPrimary}>
                {productQty}
              </Text>
            </View>
            <Pressable
              testID={tID('CatalogProductCard-Pressable-CountIncrease')}
              hitSlop={styles.hitSlop}
              disabled={product?.quantityAvailable === productQty}
              style={styles.arrowImgContainer}
              onPress={() => updateProductQty(productQty + 1)}>
              <UpArrowIcon
                tintColor={
                  product?.quantityAvailable === productQty
                    ? colors.borderMuted
                    : colors.link
                }
              />
            </Pressable>
          </View>
          <Button
            testID={tID('CatalogProductCard-Button-AddToCart')}
            title="Add To Cart"
            buttonType={BUTTON_TYPES.Filled}
            titleColor={colors.textOnAccent}
            style={styles.addToCartButton}
            titleStyle={styles.addToCartButtonTitle}
            onPress={onPressAddToCart}
          />
        </View>
      </View>
    </View>
  );
};

export default UI;
